import {ref} from "vue";

const pendingFile = ref(null);
const pendingUrl = ref("");

function clear() {
  const oldUrl = pendingUrl.value;
  pendingFile.value = null;
  pendingUrl.value = "";
  if (oldUrl) URL.revokeObjectURL(oldUrl);
}

function setFile(file) {
  if (!file) return;
  clear();
  pendingFile.value = file;
  pendingUrl.value = URL.createObjectURL(file);
}

export function useAvatarCropState() {
  return {pendingFile, pendingUrl, setFile, clear};
}
